<template>
    <CContainer class="align-items-center">
        <CRow>
            <CCol sm="12" lg="12">
                <CCard>
                    <CCardHeader>
                        <strong>XML</strong> <small>Import</small>
                        <div class="card-header-actions">
                                <small class="text-muted">Brandsdistribution XML-Datei Upload</small>
                        </div>
                    </CCardHeader>
                    <CCardBody>
                        <form @submit.prevent="onSubmit" enctype="multipart/form-data">
                            <CRow>
                                <CCol sm="12">
                                    <kendo-upload ref="upload"
                                                  name="files"
                                                  :async-save-url="url"
                                                  :upload="onUpload"
                                                  :validation-allowed-extensions='[".xml"]'>
                                    </kendo-upload>
                                </CCol>
                                    <div class="demo-hint mt-3 mb-3 ml-3">Sie können nur <strong>XML</strong> Dateien hochladen, welche nur aktiven Shops zugeordnet werden.</div>
                            </CRow>
                        </form>
                    </CCardBody>
                </CCard>
            </CCol>
        </CRow>
    </CContainer>
</template>

<script>

    import API from '../../config'
    import TokenService from "../../services/storage.service"

    export default {
        name: "Import",
        data:() =>({
            file: '',
            url: API.URL + 'upload'
        }),

        methods: {
            onUpload: function (e) {

                var xhr = e.XMLHttpRequest;
                if (xhr) {
                    xhr.addEventListener("readystatechange", function (e) {
                        if (xhr.readyState == 1 /* OPENED */) {
                            xhr.setRequestHeader('Authorization', 'Bearer ' + TokenService.getToken());
                        }

                        if (xhr.readyState == 4 && this.status === 200) {
                            window.location.href ='/dashboard/shops/list'
                        }
                    });
                }
            }
        },
    }
</script>

<style scoped>

</style>
